import ApiClient from ".."

// Out DTOs
import GenericOut from "../../dtos/out/GenericOut"
import ReportGetOut from "../../dtos/out/ReportGetOut"
import type ReportGetStatusOut from "../../dtos/out/ReportGetStatusOut"

export class ReportEndpoints {
  constructor(private client: ApiClient) {}
  static readonly BASE_URL = "/report"

  /**
   * Retrieves the report for the currently authenticated user.
   */
  async get() {
    return this.client.get<ReportGetOut>(ReportEndpoints.BASE_URL, "/")
  }

  /**
   * Retrieves the report status for the currently authenticated user. This can be "unavailable", "generating" or "ready".
   */
  async getStatus() {
    return this.client.get<ReportGetStatusOut>(ReportEndpoints.BASE_URL, "/status")
  }

  /**
   * Marks the user's career feedback experience as completed and regenerates their report data.
   */
  async postFeedbackExperienceCompleted() {
    return this.client.post<GenericOut>(ReportEndpoints.BASE_URL, "/complete-feedback", {})
  }

  /**
   * Regenerates new jobs for the user based on their existing data.
   */
  async putRegenerateJobs(userId: number) {
    return this.client.put<GenericOut>(ReportEndpoints.BASE_URL, `/user/${userId}/regenerate`, null)
  }
}
